"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnChainStorage = void 0;
const __1 = require("../..");
const ScoreStorage_1 = require("./ScoreStorage");
class OnChainStorage extends ScoreStorage_1.ScoreStorage {
    constructor(logger, defaultChainId, scoresCollection, statsCollection, cache) {
        super(logger);
        this.logger = logger;
        this.defaultChainId = defaultChainId;
        this.scoresCollection = scoresCollection;
        this.statsCollection = statsCollection;
        this.cache = cache;
    }
    createScores(newScores) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (newScores.length === 0)
                    return;
                // 'insertMany' is much faster than bulkWrite "upsert" (no need to run both "find()" and "update()")
                yield this.scoresCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].insertMany(newScores);
            }
            catch (error) {
                this.logger.error(`OnChainStorage::createScores => ${error}`);
            }
        });
    }
    createStats(onChainStats) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.statsCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].insertOne(onChainStats);
            }
            catch (error) {
                this.logger.error(`OnChainStorage::createStats => ${error}`);
            }
        });
    }
    readScores(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getScores(this.scoresCollection[(0, __1.getNetworkGroup)(params.chainId)], params);
        });
    }
    readScoresCount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = `${params.chainId}_${params.protocol}_${JSON.stringify(params.accounts)}_${params.epoch}_onchain_scores_count`;
            const cachedCount = this.cache.get(cacheKey);
            if (cachedCount) {
                return cachedCount;
            }
            const count = this.getScoreCount(this.scoresCollection[(0, __1.getNetworkGroup)(params.chainId)], params);
            this.cache.set(cacheKey, count);
            return count;
        });
    }
    readScoreStatistics(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const stats = (yield this.statsCollection[(0, __1.getNetworkGroup)(params.chainId)].findOne(this.handleQuery(params)));
                return stats;
            }
            catch (error) {
                this.logger.error(`OnChainStorage::readScoreStatistics => ${error}`);
            }
        });
    }
    deleteScoresBefore(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.scoresCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].deleteMany({
                    epoch: { $lt: epoch },
                });
            }
            catch (error) {
                this.logger.warning(`OnChainStorage::deleteScoresBefore => ${epoch}:${error}`);
            }
        });
    }
    deleteScoresAt(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.scoresCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].deleteMany({ epoch });
            }
            catch (error) {
                this.logger.warning(`OnChainStorage::deleteScoresAt => ${epoch}:${error}`);
            }
        });
    }
    deleteStatisticsBefore(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.statsCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].deleteMany({
                    epoch: { $lt: epoch },
                });
            }
            catch (error) {
                this.logger.warning(`OnChainStorage::deleteScoresStatistics => ${error}`);
            }
        });
    }
    deleteStatisticsAt(epoch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.statsCollection[(0, __1.getNetworkGroup)(this.defaultChainId)].deleteMany({ epoch });
            }
            catch (error) {
                this.logger.warning(`OnChainStorage::deleteStatisticsAt => ${error}`);
            }
        });
    }
    getScoreAttributeProjection() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                _id: 0,
                protocol: 1,
                active: 1,
                attach_proof: 1,
            };
        });
    }
}
exports.OnChainStorage = OnChainStorage;
//# sourceMappingURL=OnChainStorage.js.map